import React from 'react';

const Project = ({ item }) => {
  return (
    <div key={item.id} className='flex flex-col items-center text-center'>
      <div className='mb-8'>
        <a href={item.imgLink} target="_blank" rel="noopener noreferrer">
          <img className='rounded-2xl' src={item.image} alt="education-demo-site" />
        </a>
      </div>
      <p className='capitalize text-accent text-sm mb-3'>{item.category}</p>
      <h3 className='text-2xl font-semibold capitalize mb-3'>{item.name}</h3>
      <div className="flex  justify-between gap-5">
        <a href={item?.github} target="_blank" rel="noopener noreferrer" >
          <button className='btn py-2 px-3 mt-3 border rounded-xl  '>
            <p className='text-white capitalize'>View Details</p>
          </button>
        </a>
        <a href={item?.liveLink} target="_blank" rel="noopener noreferrer" >
          <button className='btn py-2 px-3 mt-3 border rounded-xl btn-sm '>
            <p className='text-white capitalize'> Live Link</p>
          </button>
        </a>
      </div>
    </div>
  );
};

export default Project;
